import { ApiClientError } from '@raydiant/api-client-js';
import { useQueryClient } from 'react-query';
import raydiant from '../clients/raydiant';
import { keys } from '../queryClient';
import useProtectedMutation from './useProtectedMutation';

export default function useDeleteCatalog() {
  const queryClient = useQueryClient();

  const mutation = useProtectedMutation<void, ApiClientError, string>(
    (id) => raydiant.deleteCatalog(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(keys.catalogs());
      },
    },
  );

  return mutation;
}
